module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-20-1c90933a29cadfd8cd61412c548774ac.jpg";